<template>
  <div :class="['posts', `display-${display}`]">
    <div class="background-strip">
      <div class="left"></div>
      <div class="right"></div>
    </div>

    <div class="branding-area">
      <div class="branding-logo">
        <img src="/static/xl_hbsc-flag_3d.png" />
      </div>
    </div>

    <post
      v-for="(post, index) in posts"
      :key="`post-${post.id}`"
      :data="post"
      :duration="durationPerPost"
      :isActive="postIsActive(index)"
      :isNext="postIsNext(index)"
      :isPrevious="postIsPrevious(index)"
      v-show="postIsActive(index) || postIsNext(index) || postIsPrevious(index)"
    />
  </div>
</template>

<script>
import Post from '@/components/Post';

import gql from 'graphql-tag';

const GET_POOL = gql`
  query Pool($id: ID!) {
    specificPool(id: $id) {
      __typename
      id
      active
      title
      search
      duration_per_chunk
      font_size
      arrangement
      geocode
      lng
      lat
      geo_radius
      sponsor_interval
      posts {
        __typename
        id
        source_ref
        order
        data
      }
    }
  }
`;

export default {
  timers: {
    nextPost: {
      autostart: false,
      repeat: true,
      immediate: false
    }
  },

  components: {
    Post
  },

  props: ['previewSettings', 'poolPreview', 'devicePool'],

  data() {
    return {
      activePostIndex: false,
      skipSpecificQuery: true,
      skipActiveQuery: true,
      display: null,
      sponsorDuration: 5,
      defaultSponsorInterval: 5,
      postCounter: 0
    };
  },

  created() {
    this.skipSpecificQuery = !this.poolPreview;
    this.skipActiveQuery = !this.skipSpecificQuery;
  },

  mounted() {
    setTimeout(() => {
      this.timers.nextPost.time = this.durationPerPost;
      this.display = 'sponsor';
    }, 0);
  },

  watch: {
    timePreview(newValue) {
      this.timers.nextPost.time = this.timePreview * 1000;
      this.$timer.stop('nextPost');
      this.$timer.start('nextPost');
    },

    activePostIndex(newValue, oldValue) {
      if (this.postCounter === this.pool.sponsor_interval) {
        this.$timer.stop('nextPost');
        this.postCounter = 0;

        setTimeout(() => {
          this.display = 'sponsor';
          this.$timer.stop('nextPost');
        }, this.durationPerPost);
      }
    },

    display(newValue, oldValue) {
      this.$emit('changeDisplay', newValue);

      if (newValue === 'sponsor') {
        setTimeout(() => {
          this.display = 'posts';
          this.nextPost();
          this.$timer.start('nextPost');
        }, this.sponsorDuration * 1000);
      }
    }
  },

  computed: {
    durationPerPost() {
      let duration = 6 * 1000;

      if (this.timePreview) {
        duration = this.timePreview * 1000;
      } else if (this.pool && this.pool.duration_per_chunk > 6) {
        duration = this.pool.duration_per_chunk * 1000;
      }

      return duration;
    },

    pool() {
      let pool;
      if (this.poolPreview) {
        pool = this.specificPool;
      } else if (this.devicePool) {
        pool = this.devicePool;
      }

      if (!pool) {
        return;
      }
      pool.posts.sort((a, b) => (a.order > b.order ? 1 : -1));
      return pool;
    },

    posts() {
      return this.pool ? this.pool.posts : null;
    },

    activePost() {
      return this.posts ? this.posts[this.activePostIndex] : null;
    }
  },

  methods: {
    postIsActive(index) {
      return index === this.activePostIndex;
    },

    postIsNext(index) {
      if (this.activePostIndex === 'sponsor' && index === 0) {
        return true;
      }

      if (this.activePostIndex + 1 === this.posts.length) {
        return index === 0;
      } else {
        return index === this.activePostIndex + 1;
      }
    },

    postIsPrevious(index) {
      if (
        this.activePostIndex === 'sponsor' &&
        index === this.posts.length - 1
      ) {
        return true;
      }

      if (this.activePostIndex === 0) {
        return index === this.posts.length - 1;
      } else {
        return index === this.activePostIndex - 1;
      }
    },

    nextPost() {
      if (this.activePostIndex + 1 < this.posts.length) {
        this.activePostIndex++;
      } else {
        this.activePostIndex = 0;
      }
      this.postCounter++;
    }
  },

  apollo: {
    specificPool: {
      query: GET_POOL,
      pollInterval: 1000 * 10,
      variables() {
        return {
          id: this.$route.params.id ? this.$route.params.id : false
        };
      },
      skip() {
        return this.skipSpecificQuery;
      }
    }
  }
};
</script>

<style lang="scss">
.background-strip {
  position: absolute;
  top: 20vh;
  bottom: 2vh;
  left: 0;
  right: 0;

  .right,
  .left {
    position: absolute;
    top: 0;
    bottom: 0;
    background-color: #fff;

    transition: all 0.7s ease-in-out;
  }

  .right {
    right: 0;
    width: 71vw;
    transform: translateX(75vw);
  }

  .left {
    left: 0;
    width: 30vw;
    transform: translateX(-35vw);
  }

  .display-posts & {
    .left,
    .right {
      transform: translateX(0);
    }
  }
}

.branding-area {
  position: absolute;
  display: flex;
  left: 0;
  right: 0;
  top: 20vh;
  bottom: 0;
  justify-content: center;
  align-items: center;
  z-index: 0;

  opacity: 0;
  transform: scale(0.2);
  transition: all 0.7s ease-in-out;

  .display-sponsor & {
    opacity: 1;
    transform: scale(1);
  }

  .branding-logo {
    width: 30vw;
    height: 50vh;

    img {
      height: 100%;
      width: auto;
      margin: 0 auto;
    }
  }
}

.post {
  font-size: 5.5vh;
  font-weight: 700;
  color: #00428c;

  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;

  margin: 0;
}

.card-body {
  .content {
    position: absolute;
    top: 27vh;
    left: 55vw;
    width: 42vw;
    line-height: 1.2em;
    z-index: 5;
  }
}

.image {
  position: absolute;
  width: 50%;
  top: 5vh;
  bottom: 5vh;
  left: 5vh;

  z-index: 10;

  background-size: cover;
  border-radius: 0.8vh;
  background-position: center;

  transition: all 0.7s ease-in-out;

  .post.active & {
    transform: translateY(0);

    .display-sponsor & {
      transform: translateY(-100vh);
    }
  }

  .post.prev &,
  .display-sponsor & {
    transform: translateY(-100vh);
  }

  .post.next & {
    transform: translateY(100vh);
  }

  &:after {
    position: absolute;
    content: '';
    left: -1.2vh;
    right: -1.2vh;
    top: -1.2vh;
    bottom: -1.2vh;
    border-radius: 2vh;
    border: 1.2vh solid rgba(255, 255, 255, 0.3);
  }

  img.social-icon {
    position: absolute;
    bottom: -3.5vw;
    left: -3.5vw;

    width: 8vw;
    height: auto;

    transition: all 0.3s ease-in-out;
    transition-delay: 0.6s;
    transform: scale(0.7) rotate(-30deg);

    .active & {
      transform: scale(1) rotate(0);
    }
  }
}

.user {
  z-index: 15;
  font-size: 5vh;
  background-color: #fff;
  display: inline-block;
  border-radius: 1em;
  padding: 0.2em 0.5em 0.3em;
  line-height: 1em;
  font-weight: 400;
  position: absolute;
  left: 55vw;
  top: 16vh;
  opacity: 0;
  box-shadow: 0 0.3rem 1em rgba(0, 0, 0, 0.3);

  transition: 0.7s all ease-in-out;

  .post.active & {
    opacity: 1;

    .display-sponsor & {
      opacity: 0;
    }
  }

  .screen-name {
    display: flex;
    flex-direction: row;
    letter-spacing: 0.03em;

    img.icon {
      display: none;
      &.instagram {
        width: 1.1em;
        margin-right: 0.3em;
      }

      &.twitter {
        width: 1.9em;
        margin-top: -0.5em;
      }
    }
  }
}
</style>
